/*
 * @Author: 刘小博
 * @Date: 2023-02-17 14:17:56
 * @LastEditTime: 2023-02-17 14:29:59
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\abutment-module\abutment-manage\modules\systemSettings.js
 * 系统配置
 */
const systemSettings = [
  // 对接模块 系统配置
  {
    path: '/s2pDataApi/system-set',
    name: 's2pSystemSetToSet',
    component: () =>
      import(
        /*webpackChunkName:"s2pSystemSet" */
        '@/views/s2pSystemSet/SystemSet.vue'
        ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '系统设置',
    },
  },
  // 对接模块 系统配置 接口数据方式配置
  {
    path: '/s2pSystemSet/api-data-set',
    name: 's2pSystemSetApiDataSet',
    component: () =>
      import(
        /*webpackChunkName:"s2pSystemSet" */
        '@/views/s2pSystemSet/ApiDataSet.vue'
        ),
    meta: {
      SecondaryMenu: '接口数据配置', //二级菜单
      title: '接口数据配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 's2pSystemSetToSet',
        },
      ],
    },
  },


  // 对接模块 系统配置 对接消息通知
  {
    path: '/s2pSystemSet/api-docking-notice',
    name: 's2pSystemSetApiDockingNotice',
    component: () =>
      import(
        /*webpackChunkName:"s2pSystemSet" */
        '@/views/s2pSystemSet/ApiDataSetting.vue'
        ),
    meta: {
      SecondaryMenu: '系统配置', //二级菜单
      title: '对接消息通知',
    },
  },


  // 对接模块 系统配置 对接消息通知 编辑
  {
    path: '/s2pSystemSet/api-docking-notice/edit/:id',
    name: 's2pSystemSetApiDataSettingEdit',
    component: () =>
      import(
        /*webpackChunkName:"s2pSystemSet" */
        '@/views/s2pSystemSet/ApiDataSettingEdit'
        ),
    meta: {
      SecondaryMenu: '系统配置', //二级菜单
      title: '新增配置',
      breadcrumb: [
        {
          title: '对接消息通知',
          name: 's2pSystemSetApiDockingNotice',
        },
      ],
    },
  },

]

export default systemSettings
